import Scene from '../Scene';
import common from '../../common';
import Text from '../../ui/Text';
import i18next from 'i18next';

export default class NewsScene extends Scene {
	constructor() {
		super();

		this._background = null;
		this._tablet = null;
		this._strings = { // We need one of these for every scenario. And gotta rework it to change with difficulty.
			COST: common.numberWithCommas(common.scenario.disaster.totalCost),
			DEATHTOLL: common.scenario.disaster.totalDeaths,
			INJURYTOLL: common.scenario.disaster.totalInjury,
			COMMENT: '',
			OUTCOME: '',
		};

		this._dateOptions = {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		};

		this._languageChangeSignal = common.languageManager.signals.changed.add(this.onLanguageChange, this);
	}

	init() {
		super.init();

		this.interactive = true;
		this.on('pointerup', () => {
			P3.audio.playSound('sfx_genericclick');
		});

		this._background = new PIXI.Graphics();

		this._background.beginFill(0x0, 0.6);
		this._background.drawRect(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT);
		this._background.endFill();
		this._background.interactive = true;
		this.addChild(this._background);

		this._tablet = new PIXI.NineSlicePlane(P3.assets.texture('tablet_9slice'), 130, 70, 130, 80);
		this._tablet.width = 1275;
		this._tablet.height = 768;
		this._tablet.position.set(common.STAGE_WIDTH * 0.5 - this._tablet.width * 0.5, common.STAGE_HEIGHT * 0.5 - this._tablet.height * 0.5);
		this.addChild(this._tablet);

		const homeButton = new PIXI.Sprite(P3.assets.texture('tablet_button'));

		homeButton.anchor.set(0.5);
		homeButton.position.set(this._tablet.width - 80, this._tablet.height * 0.5);
		this._tablet.addChild(homeButton);

		const speakers = new PIXI.Sprite(P3.assets.texture('tablet_speaker'));

		speakers.anchor.set(0.5);
		speakers.position.set(80, this._tablet.height * 0.5);
		this._tablet.addChild(speakers);

		this._tablet.header = this._createHeader();
		this._tablet.header.position.set(0, 110);
		this._tablet.addChild(this._tablet.header);

		this._tablet.body = this._createBody();
		this._tablet.body.position.set(0, 200);
		this._tablet.addChild(this._tablet.body);

		/* this.alpha = 0;
        new TWEEN.Tween(this, this.tweens)
            .to({
                alpha: 1
            }, 600)
            .easing(TWEEN.Easing.Back.Out)
            .start();*/
	}

	_createHeader() {
		const header = new PIXI.Container();

		header.title = new Text('gui.newsscene.header.title', { font: '70px', fontWeight: 'bold', align: 'center', tint: 0xC20009 });
		header.title.anchor.set(0.5);
		header.title.position.set(this._tablet.width * 0.5, 0);
		header.addChild(header.title);

		while (header.title.width > 650) {
			header.title.style.fontSize = `${parseInt(header.title.style.fontSize) - 1}px`;
		}

		header.date = new Text(new Date().toLocaleDateString(common.config.language.replace('_', '-'), this._dateOptions), { font: '26px', align: 'left', tint: 0x0, maxWidth: 100 });
		header.date.anchor.set(0, 0.5);
		header.date.position.set(200, 0);
		header.addChild(header.date);

		header.divider = new PIXI.Container();
		header.divider.position.set(this._tablet.width * 0.5, 60);
		header.addChild(header.divider);

		header.divider.top = new PIXI.Sprite(P3.assets.texture('divider'));
		header.divider.top.anchor.set(0.5);
		header.divider.top.width = this._tablet.width - 300;
		header.divider.addChild(header.divider.top);

		header.divider.bottom = new PIXI.Sprite(P3.assets.texture('divider'));
		header.divider.bottom.anchor.set(0.5);
		header.divider.bottom.width = this._tablet.width - 300;
		header.divider.bottom.position.set(0, 5);
		header.divider.addChild(header.divider.bottom);

		return header;
	}

	_createBody() {
		const body = new PIXI.Container();

		body.image = new PIXI.Sprite(P3.assets.texture(`news_${common.selectedLevel}`));
		body.image.scale.set(0.5);
		body.image.position.set(150, 0);
		body.addChild(body.image);

		body.title = new Text(`${common.selectedLevel}.news.title`, { font: '40px', fontWeight: 'bold', align: 'left', tint: 0x0 });
		body.title.anchor.set(0);
		body.title.position.set(body.image.x + body.image.width + 15, body.image.y - 5);
		body.addChild(body.title);

		let comments = common.scenario.disaster.hospitalDestroyed ? i18next.t(`${common.selectedLevel}.news.body.hospitaldown`) : '';

		comments += common.scenario.disaster.schoolDestroyed ? i18next.t(`${common.selectedLevel}.news.body.schooldown`) : '';
		this._strings.COMMENT = comments;

		const outcome1 = common.scenario.win ? i18next.t(`${common.selectedLevel}.news.body.outcome_positive`) : i18next.t(`${common.selectedLevel}.news.body.outcome_negative`);

		this._strings.OUTCOME = outcome1;

		const outcome2 = common.scenario.ccUpgrades.length > 0 ? '.news.body.positive' : '.news.body.negative';
		const bodycontent = i18next.t(common.selectedLevel + outcome2, this._strings);

		body.bodyText = new Text(bodycontent, { font: '30px', align: 'left', tint: 0x0, maxWidth: this._tablet.width - 150 - body.title.x });
		body.bodyText.anchor.set(0);
		body.bodyText.position.set(body.title.x, body.title.y + 40);
		body.addChild(body.bodyText);

		while (body.bodyText.height > 400) {
			body.bodyText.style.fontSize = `${parseInt(body.bodyText.style.fontSize) - 1}px`;
		}

		body.sceneButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_black_outline_9slice_out', width: 260, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_black_outline_9slice_over', width: 260, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});
		body.sceneButton.position.set(600 + body.sceneButton.width * 0.5, 400 + body.sceneButton.height * 0.5);
		body.sceneButton.signals.click.add(() => {
			this.signals.previous.dispatch(this);
		}, this);
		body.addChild(body.sceneButton);

		body.sceneButton.label = new Text('gui.newsscene.buttons.next', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0x0 });
		body.sceneButton.label.anchor.set(0.5);
		body.sceneButton.animation.addChild(body.sceneButton.label);

		body.sceneButton.accessibleTitle = body.sceneButton.label.text;

		body.reportButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_blue_fill_large_9slice_out', width: 260, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_blue_fill_large_9slice_over', width: 260, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});
		body.reportButton.position.set(880 + body.reportButton.width * 0.5, 400 + body.reportButton.height * 0.5);
		body.reportButton.signals.click.add(() => {
			this.signals.next.dispatch(this);
		}, this);
		body.addChild(body.reportButton);

		body.reportButton.label = new Text('gui.newsscene.buttons.report', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0xFFFFFF });
		body.reportButton.label.anchor.set(0.5);
		body.reportButton.animation.addChild(body.reportButton.label);

		body.reportButton.accessibleTitle = body.reportButton.label.text;

		if (body.bodyText.y + body.bodyText.height > body.sceneButton.y - body.sceneButton.height * 0.5) {
			body.bodyText.height = body.sceneButton.y - (body.bodyText.y + body.sceneButton.height * 0.5 + 10);
			body.bodyText.scale.x = body.bodyText.scale.y;
		}

		return body;
	}

	onLanguageChange() {
		const outcome1 = common.scenario.win ? i18next.t(`${common.selectedLevel}.news.body.outcome_positive`) : i18next.t(`${common.selectedLevel}.news.body.outcome_negative`);
		const outcome2 = common.scenario.ccUpgrades.length > 0 ? '.news.body.positive' : '.news.body.negative';

		let comments = common.scenario.disaster.hospitalDestroyed ? i18next.t(`${common.selectedLevel}.news.body.hospitaldown`) : '';

		comments += common.scenario.disaster.schoolDestroyed ? i18next.t(`${common.selectedLevel}.news.body.schooldown`) : '';

		this._strings.COMMENT = comments;
		this._strings.OUTCOME = outcome1;

		this._tablet.body.bodyText.text = i18next.t(common.selectedLevel + outcome2, this._strings);
		this._tablet.header.date.text = new Date().toLocaleDateString(common.config.language.replace('_', '-'), this._dateOptions);
	}

	destroy() {
		common.languageManager.signals.changed.detach(this._languageChangeSignal, this);

		super.destroy();
	}

	resize() {
		super.resize();
		this._tablet.position.set(common.STAGE_WIDTH * 0.5 - this._tablet.width * 0.5, common.STAGE_HEIGHT * 0.5 - this._tablet.height * 0.5);
		this._background.width = common.STAGE_WIDTH;
		this._background.height = common.STAGE_HEIGHT;
	}

	update() {
		super.update();
	}
}
